<template>
  <v-container fluid class="exams">
    <v-card flat>
      <v-card-title>
        <v-btn text small @click="$router.back()">
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="withdrawalForm">
          <v-row>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Programme"
                v-model="currentProgramme.programme"
                readonly
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Intake Year"
                v-model="currentProgramme.intakeYear"
                readonly
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Intake Semester"
                v-model="currentProgramme.intakeSemester"
                readonly
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Stage"
                v-model="currentProgramme.intakeStage"
                readonly
                outlined
                dense
              />
            </v-col>
          </v-row>
        </v-form>
        <v-data-table :headers="headers" :items="bookedUnits" v-if="!isEdit">
          <template v-slot:[`item.ID`]="{ index }">
            <span>{{ index + 1 }}</span>
          </template>
        </v-data-table>
        <v-data-table
          v-else-if="isEdit || isReadonly"
          :headers="lineHeaders"
          :items="formData.examWithdrawalLines"
          :items-per-page="5"
          class="elevation-0"
          item-key="reg_no"
        >
          <template v-slot:[`item.ID`]="{ index }">
            <span>{{ index + 1 }}</span>
          </template>
          <template v-slot:[`item.amount`]="{ item }">
            <span>{{ item.amount | currencyFormat }}</span>
          </template>
        </v-data-table>
        <div class="attachment--documents">
          <v-chip-group
            active-class="orange darken-2"
            column
            multiple
            class="mx-2"
          >
            <v-chip
              v-for="(item, i) in attachments"
              :key="i"
              color="primary"
              outlined
              label
              :disabled="isReadonly"
            >
              <v-btn
                left
                color="primary"
                class="text-capitalize"
                text
                @click="editAttachment(item, i)"
                :disabled="isReadonly"
              >
                {{ item.fileName }}
              </v-btn>
              <v-divider vertical></v-divider>
              <v-tooltip bottom>
                <template v-slot:activator="{ attrs, on }">
                  <v-btn
                    class="py-2 ml-4"
                    icon
                    :disabled="isReadonly"
                    right
                    v-on="on"
                    v-bind="attrs"
                    color="deep-orange"
                    @click="removeAttachment(i, item)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </template>
                <span>Remove Attachment</span>
              </v-tooltip>
            </v-chip>
          </v-chip-group>
          <div class="d-flex justify-center flex-column">
            <div
              :class="
                attachments.length !== 0
                  ? 'align-self-center mt-3'
                  : 'align-self-center'
              "
            >
              <WithdrawalAttachments
                :isEdit="isEdit"
                :BtnCaption="BtnCaption"
                @addAttachment="addAttachment"
                :isReadonly="isReadonly"
                :data="displayAttachment"
              />
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="primary mr-5 mb-4"
          @click="isEdit ? updateWithdrawal() : requestWithdrawalApproval()"
          v-if="!isReadonly"
        >
          <v-icon class="mr-2">schedule_send</v-icon>
          {{ isEdit ? "update withdrawal" : "request for withdrawal" }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <ExamWithdrawalDialog
      v-if="!this.$route.params.code"
      :examWithdrawalDialog="examWithdrawalDialog"
      @setExamWithdrawalModal="setExamWithdrawalModal"
    />
  </v-container>
</template>

<script>
import ExamWithdrawalDialog from "./ExamWithdrawalDialog.vue";
import WithdrawalAttachments from "./WithdrawalAttachments.vue";
import { helper } from "@/packages/dashboard/utils";
export default {
  name: "ExamWithdrawalCard",
  components: { ExamWithdrawalDialog, WithdrawalAttachments },
  data() {
    return {
      attachments: [],
      displayAttachment: {},
      examWithdrawalDialog: true,
      formData: {
        DocumentType: "Withdrawal",
        programme: "",
        stage: "",
        studentNo: "",
        profileID: "",
        attachmentAPI: [],
        examWithdrawalLines: [],
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      if (v.$route.params.code) {
        v.$store.dispatch("Withdrawal/getExamWithdrawal", v.$route.params.code);
      }
    });
  },
  computed: {
    currentProgramme() {
      return this.$store.getters["Dashboard/currentProgramme"].filter(
        (item) => item.current,
      )[0];
    },
    headers() {
      return [
        { text: "#S/N", value: "ID", sortable: false },
        { text: "Unit", value: "unit", sortable: false },
        { text: "Paper", value: "paper", sortable: false },
        { text: "Invoice Number", value: "postedInvoiceNo", sortable: false },
      ];
    },
    lineHeaders() {
      return [
        { text: "#S/N", value: "ID", sortable: false },
        { text: "Unit Code", sortable: true, value: "unit" },
        {
          text: "Unit Description",
          align: "start",
          sortable: false,
          value: "description",
        },
        { text: "amount", sortable: false, value: "amount" },
      ];
    },
    bookedUnits() {
      return this.currentProgramme.studentunits.filter((item) => item.taken);
    },
    withdrawal() {
      return this.$store.getters["Withdrawal/withdrawalGetters"]("withdrawal");
    },
    isEdit() {
      return this.$route.params.code && this.formData.status === "Open";
    },
    BtnCaption() {
      return this.attachments.length === 0
        ? "Upload Documents"
        : "Add Document";
    },
    isReadonly() {
      return this.$route.params.code && this.formData.status !== "Open";
    },
  },
  methods: {
    setExamWithdrawalModal: function (value) {
      this.examWithdrawalDialog = value;
    },
    async addAttachment(file) {
      this.displayAttachment = {};
      if (file.index !== undefined) {
        Object.assign(this.attachments[file.index], file);
        delete this.attachments[file.index].index;
      } else {
        delete file.index;
        this.attachments.push(file);
      }
    },
    requestWithdrawalApproval() {
      this.submitting = true;
      if (this.attachments.length === 0) {
        Event.$emit(
          "ApiError",
          "Minimum of two documents(Withdrawal Letter and Reason) is required to proceed!",
        );
        console.log("yes");
      } else {
        this.formData.programme = this.currentProgramme.programme;
        this.formData.stage = this.currentProgramme.intakeStage;
        this.formData.studentNo = this.currentProgramme.studentNo;
        this.formData.profileID = this.currentProgramme.profileID;
        const data = { ...this.formData };
        Array.prototype.push.apply(data.attachmentAPI, this.attachments);
        delete data.examWithdrawalLines;
        this.$store.dispatch("Withdrawal/examWithdrawals", {
          ...data,
        });
        this.$router.back();
      }
    },
    updateWithdrawal() {
      if (this.attachments.length === 0) {
        Event.$emit(
          "ApiError",
          "Minimum of two documents(Withdrawal Letter and Reason) is required to proceed!",
        );
      } else {
        const data = { ...this.formData };
        data.attachmentAPI = [];
        Array.prototype.push.apply(data.attachmentAPI, this.attachments);
        delete data.examWithdrawalLines;
        this.$store.dispatch("Withdrawal/updateWithdrawal", {
          ...data,
        });
      }
    },
    removeAttachment(index, item) {
      if (item.lineNo) {
        this.$confirm.show({
          title: `Delete Withdrawal Attachment ${item.lineNo}?`,
          text: "Are you sure you want to delete this withdrawal Attachment, this action is irreversible",
          onConfirm: () => {
            this.$store.dispatch("Withdrawal/deleteAttachment", { ...item });
          },
        });
      } else {
        this.attachments.splice(index, 1);
      }
    },
    editAttachment(val, index) {
      val.index = index;
      this.displayAttachment = val;
      this.setAttachmentDialog(true);
    },
    setAttachmentDialog(val) {
      this.$store.dispatch("Withdrawal/setAttachmentDialog", val);
    },
  },
  watch: {
    withdrawal: {
      handler: function (data) {
        const attachments = data.attachmentAPI;
        delete data.attachmentAPI;
        this.formData = { ...data };
        const base64Attachments = [];
        attachments.map(async (el) => {
          const blob = await helper.getFileBlob(
            process.env.VUE_APP_TEMP_URL + el.base64Attachment,
            el.documentNo,
          );
          const base64 = await helper.toBase64(blob);
          base64Attachments.push({
            base64Attachment: base64.split(",")[1],
            fileName: `${blob.name}${el.lineNo}.${blob.type.split("/")[1]}`,
            comment: el.comment,
            blob,
            lineNo: el.lineNo,
            documentNo: el.documentNo,
            documentType: el.documentType,
          });
        });
        this.attachments = base64Attachments;
      },
    },
  },
};
</script>
<style scoped>
.attachment--documents {
  border-radius: 4px;
  padding: 1% 0 1% 0;
  border: 3px dashed green;
  background: #388e3c17;
}
</style>
